import { useState, useEffect, useRef } from "react";
import Cookies from 'universal-cookie'
import myClassNames from './myClassNames.module.scss';
import useGeneralStore from '../../store/general';
import { useResponseHandler } from '../../common/auth';
import './DownloadComponent.scss';

const DownloadComponent = ({
    setFilesArr,
    filesdata,
    isSaveFiles,
    setIsSaveFiles,
    setFilesData,
    setSaveFile,
    comment_id,
    type,
    refProgress,
    uploadProgress,
    setUploadProgress,
    setIsModalUploadProgress,
    isAuthor
}) => {
    // Обработка ошибок
    const { handleStatusCode } = useResponseHandler();

    const cookies = new Cookies()
    const token = cookies.get('auth')
    const selectedSpace = useGeneralStore(state => state.selectedSpace)
    const [files, setFiles] = useState([])
    const [save, setSave] = useState([])

    // Обработчик выбора файлов
    const handleFileSelect = (event) => {
        const selectedFiles = Array.from(event.target.files);
        if (selectedFiles.length > 0) {
            setFiles(selectedFiles);
        }
        
        // Сбрасываем значение input, чтобы можно было выбрать те же файлы снова
        event.target.value = '';
    };

    // Функция для загрузки одного файла
    const uploadSingleFile = (file) => {
        return new Promise((resolve, reject) => {
            const fd = new FormData();
            fd.append('file', file);
            const url = `https://file.ecomru.ru:4453/api/v1/file/upload`;

            const xhr = new XMLHttpRequest();

            xhr.open('POST', url, true);
            xhr.setRequestHeader('Accept', 'application/json');
            xhr.setRequestHeader('Cache-control', 'no-cache');
            xhr.setRequestHeader('Authorization', `Bearer ${token}`);
            xhr.setRequestHeader('Space', selectedSpace?.value);

            // Отслеживаем прогресс загрузки для конкретного файла
            xhr.upload.addEventListener('progress', (event) => {
                if (event.lengthComputable) {
                    const percent = Math.round((event.loaded * 100) / event.total);

                    // Получаем текущие имена файлов в прогрессе
                    const currentFileNames = Object.keys(uploadProgress);

                    // Проверяем, есть ли файлы с таким же именем
                    const sameNameFiles = currentFileNames.filter(name =>
                        name === file.name || name.startsWith(`${file.name} (`)
                    );

                    let fileNameToUse = file.name;

                    // Если есть файлы с таким же именем, добавляем порядковый номер
                    if (sameNameFiles.length > 0) {
                        // Находим максимальный порядковый номер среди файлов с таким же именем
                        let maxNumber = 0;

                        sameNameFiles.forEach(existingFileName => {
                            if (existingFileName === file.name) {
                                maxNumber = Math.max(maxNumber, 1);
                            } else {
                                // Извлекаем число из формата "filename (2)"
                                const match = existingFileName.match(/\((\d+)\)$/);
                                if (match && match[1]) {
                                    const number = parseInt(match[1], 10);
                                    maxNumber = Math.max(maxNumber, number);
                                }
                            }
                        });

                        // Увеличиваем номер на 1 для нового файла
                        const nextNumber = maxNumber + 1;
                        fileNameToUse = `${file.name} (${nextNumber})`;
                    }

                    setUploadProgress(prev => ({
                        ...prev,
                        [fileNameToUse]: percent
                    }));
                }
            });

            xhr.onload = () => {
                if (handleStatusCode(xhr.status)) {
                    reject(new Error(`HTTP error: ${xhr.status}`));
                    return;
                }
                if (xhr.status === 200) {
                    const json = JSON.parse(xhr.responseText);
                    if (json) {
                        const current = {
                            new_filename: json?.name,
                            url: json?.url,
                            file_size_kb: json?.size,
                            created_at: json?.created_at,
                            extension: json?.extension
                        }
                        resolve(current);
                    } else {
                        reject(new Error('Invalid response format'));
                    }
                } else {
                    reject(new Error(`Upload failed: ${xhr.statusText}`));
                }
            };

            xhr.onerror = () => {
                reject(new Error('Error occurred during file upload'));
            };

            xhr.send(fd);
        });
    };

    // Функция для одновременной загрузки всех файлов
    const uploadMultipleFiles = async (filesToUpload) => {
        try {
            // Создаем массив промисов для загрузки всех файлов
            const uploadPromises = filesToUpload.map(file => uploadSingleFile(file));

            // Ждем завершения всех загрузок
            const results = await Promise.all(uploadPromises);

            // Обрабатываем успешные результаты
            const successfulUploads = results.filter(result => result !== null);

            if (successfulUploads.length > 0) {
                if (type === 'description') {
                    setSaveFile(successfulUploads);
                } else {
                    setSaveFile((prev) => [...prev, ...successfulUploads]);
                }
            }

            // Сбрасываем прогресс после завершения всех загрузок
            setTimeout(() => {
                setUploadProgress({});
            }, 1000);

            // Очищаем файлы
            setFiles([]);

            return successfulUploads;
        } catch (error) {
            console.error('Error uploading files:', error);
            return [];
        }
    };

    // Обработка новых файлов
    useEffect(() => {
        if (files.length > 0) {
            // Загружаем все файлы одновременно
            setIsModalUploadProgress(true)
            uploadMultipleFiles(files);
        }
    }, [files]);

    // Обновление filesArr при изменении save
    useEffect(() => {
        if (filesdata?.length > 0) {
            let arr = filesdata.map((el) => el.value)
            setFilesArr([...save])
        } else {
            setFilesArr(save)
        }
    }, [save]);

    // Обновление filesData при добавлении новых файлов
    useEffect(() => {
        if (save.length > 0) {
            setFilesData(save)
            setFilesArr([...filesdata, ...save])
        }
    }, [save]);

    // Инициализация filesData
    useEffect(() => {
        setFilesData([...filesdata])
    }, []);

    return (
        <>
            <div className={myClassNames.container}>
                <input
                    type="file"
                    multiple
                    accept=".png,.jpg,.jpeg,.gif,.bmp,.tiff,.txt,.pdf,.doc,.docx,.xls,.xlsx,.xml,.swf,.avi,.mpg,.mpeg,.mpv,.mp4,.m4e,.m4v,.mp3,.m3u,.wma,.wmv,.js,.jsx,.css,.htm"
                    onChange={handleFileSelect}
                    className={`download-component`}
                />
            </div>
        </>
    );
}

export { DownloadComponent }